
import React from 'react';
import { CreditCard, ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface StripeConnectionButtonProps {
  isConnecting: boolean;
  onConnect: () => void;
}

const StripeConnectionButton: React.FC<StripeConnectionButtonProps> = ({
  isConnecting,
  onConnect,
}) => {
  return (
    <div className="text-center py-8">
      <div className="bg-gray-50 p-4 inline-flex items-center justify-center rounded-full mb-4">
        <CreditCard className="h-10 w-10 text-keepmore-purple" />
      </div>
      <h2 className="text-xl font-semibold mb-2">Connect Your Stripe Account</h2>
      <p className="text-gray-500 max-w-md mx-auto mb-6">
        Connect your existing Stripe account or create a new one to start accepting payments through KeepMore.
      </p>
      <Button 
        onClick={onConnect}
        className="gradient-bg"
        disabled={isConnecting}
      >
        {isConnecting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Connecting...
          </>
        ) : (
          <>
            Connect Stripe Account
            <ArrowRight className="ml-2 h-4 w-4" />
          </>
        )}
      </Button>
    </div>
  );
};

export default StripeConnectionButton;
